(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const header = document.getElementById('fw-sticky-header');
  let ticking = false;
  const updateHeader = () => {
    ticking = false;
    if (header) header.classList.toggle('fw-is-scrolled', scrollY > 16);
  };
  updateHeader();
  addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(updateHeader); }
  }, { passive: true });
  const animated = new Set();
  const animate = (element, frames, options) => {
    if (motion.matches || !element.animate) return;
    const animation = element.animate(frames, options);
    animated.add(animation);
    animation.finished.catch(() => {}).finally(() => animated.delete(animation));
  };
  const revealSelector = '.fw2-story__copy,.fw2-feat__card,.fw-step,.fw-angle-card,.fwp-how__step,.fw-help-card,.fwx-box';
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        animate(entry.target, [{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 480, easing: 'cubic-bezier(.22,.61,.36,1)' });
      });
    }, { threshold: .08 });
    document.querySelectorAll(revealSelector).forEach(element => {
      if (element.getBoundingClientRect().top >= innerHeight) observer.observe(element);
    });
    motion.addEventListener('change', () => {
      if (motion.matches) { observer.disconnect(); animated.forEach(animation => animation.cancel()); }
    });
  }
  document.querySelectorAll('.fw2-faq__card details,.fw-faq details,.fwp__acc details').forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      [...detail.children].filter(child => child.tagName !== 'SUMMARY').forEach(child => {
        animate(child, [{ opacity: .6, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'ease-out' });
      });
    });
  });
  const dialog = document.getElementById('fw-photo-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const photo = dialog.querySelector('img');
  const closeButton = dialog.querySelector('button');
  let returnTo = null, previousOverflow = '', closeTimer;
  const close = () => {
    if (!dialog.open || dialog.hasAttribute('data-closing')) return;
    dialog.setAttribute('data-closing', '');
    closeTimer = setTimeout(() => dialog.close(), motion.matches ? 0 : 320);
  };
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', () => {
    clearTimeout(closeTimer);
    dialog.removeAttribute('data-closing');
    document.body.style.overflow = previousOverflow;
    if (returnTo && returnTo.isConnected) returnTo.focus({ preventScroll: true });
  });
  const targets = '.fwp__model-photos>img,.fw-angle-card__image img,.fw2-story__img img,.fw2-alt__img img';
  document.querySelectorAll(targets).forEach(image => {
    if (image.closest('a,button')) return;
    let container = image.parentElement;
    if (container.classList.contains('fwp__model-photos')) {
      container = document.createElement('div');
      container.className = 'fw-photo-target--model';
      image.before(container);
      container.append(image);
    }
    if (container.querySelector('.fw-photo-open')) return;
    container.classList.add('fw-photo-target');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fw-photo-open';
    button.setAttribute('aria-label', dialog.dataset.openLabel + ': ' + image.alt);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', dialog.id);
    button.innerHTML = '<span aria-hidden="true"><svg viewBox="0 0 24 24" stroke-width="1.7" stroke-linecap="round"><circle cx="10" cy="10" r="6.5"/><path d="M15 15l5 5M7 10h6M10 7v6"/></svg></span>';
    button.addEventListener('click', () => {
      clearTimeout(closeTimer);
      dialog.removeAttribute('data-closing');
      returnTo = button;
      previousOverflow = document.body.style.overflow;
      photo.src = image.currentSrc || image.src;
      photo.alt = image.alt;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      closeButton.focus({ preventScroll: true });
    });
    container.append(button);
  });
})();
